// extracted by mini-css-extract-plugin
export default {"cls1":"Pagination-Container_cls1__b-7cV","cls2":"Pagination-Container_cls2__s2AnX Pagination-Container_cls1__b-7cV"};